import api from '../common/api';
import { APIError } from '../constants/errorCode/system';
import httpHelper from '../helpers/httpHelper';
import BaseServices from './baseServices';

export default {
  getMenuServices: async () => {
    try {
      const url = api.oryton.getMenuServices;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getCompanyByUser: async (payload) => {
    try {
      const query = httpHelper.serialize(payload);
      const url = api.company.getOrytonCompanies + `?${query}`;
      console.log(21, url);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getOwnCompanys: async () => {
    try {
      const url = api.company.getOwnCompany;
      const data = await BaseServices.getOrytonDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getInbox: async (params) => {
    try {
      const query = httpHelper.serialize(params);
      const url = `${api.oryton.getInbox}?${query}`;
      const data = await BaseServices.getOrytonDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  listUsers: async () => {
    try {
      const url = api.oryton.listUsers;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  renewSubscription: async (url) => {
    try {
      const data = await BaseServices.postDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  fetchResponsibleAccountants: async () => {
    try {
      const url = api.oryton.listAccountants;
      const data = await BaseServices.getOrytonDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getCompanyStartEnd: async (companyIds) => {
    // str 12,333
    try {
      const url = api.oryton.getCompanyStartEnd + '?company=' + companyIds;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  findUser: async (email) => {
    try {
      const url = api.oryton.findUser + `?filterSearchText=${email}`;
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getFikenCompany: async (companyId) => {
    try {
      const url = api.oryton.getFikenCompany.replace(':companyId', companyId);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getCompanyStripeCards: async (companyId) => {
    try {
      const url = api.oryton.getCompanyStripeCards.replace(':companyId', companyId);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getTripletexCompany: async (companyId) => {
    try {
      const url = api.oryton.getTripletexCompany.replace(':companyId', companyId);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  getAccountingInvivation: async (orgnr) => {
    try {
      if (!orgnr) throw Error('Missing Data');
      const url = api.oryton.getAccountingInvitation.replace(':orgnr', orgnr);
      const data = await BaseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
  updateAccountingInvivation: async (accountingCompanyId, orgnr, payload = {}) => {
    try {
      if (!payload?.Status || !orgnr || !accountingCompanyId) throw Error('Missing Data');

      const url = api.oryton.updateAccountingInvitation
        .replace(':accountingCompanyId', accountingCompanyId)
        .replace(':orgnr', orgnr);

      const data = await BaseServices.putDataToken(url, payload);
      const result = await data.json();
      return result;
    } catch (error) {
      return { isSuccess: false, code: APIError.ConnectFail };
    }
  },
};
